import { supabase } from '@/lib/supabase'

/** Founding-member subscriber count (used on the public pricing page). */
export async function getFoundingMemberCount() {
  const { data, error } = await supabase.rpc('get_founding_member_count')
  if (error) throw error
  return data || 0
}
